export const metaDataKeys = {
  // for showing first time questionnaire
  questionnaireFirstTimeMetaKey: "questionnaire_first_time",
  // to show terms page in navigation becausse is a generic page
  termsPageMetaKey: "termsPage",
  footerWarningMetaKey: "footerWarning",
  registerWarningMetaKey: "registerWarning",
};
